import { render, staticRenderFns } from "./GPSGate.vue?vue&type=template&id=f2464722&"
import script from "./GPSGate.vue?vue&type=script&lang=js&"
export * from "./GPSGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports